export const boardsSubtitles = {
  BOARD: 'Boards',
  BASIC_BOARD: 'Boards',
  COUNCIL: 'Councils',
};
